export default "/_next/static/images/ai-edit-card-35f87edce6e5fbe99f77e54602f75652.png";